import React from 'react'
import './Cover.css'

const Cover = (props) => (
  <div className='cover'>
    <div className='cover__image'>
      <img src={props.image} alt={props.title} />
    </div>
    <div className='cover__title'>
      <h1>{props.title}</h1>
    </div>
  </div>
)

export default Cover
